import IConfig from './IConfig'

const prodConfig: IConfig = {
  auth: {
    clientId: 'Mc9fyWuKfUM2fs61RWp9jkKNrYVBbcAv',
    domain: 'firmus.us.auth0.com',
    serverApiId: 'https://firmus.ninja/manual-team-viewer/api',
  },
}

export default prodConfig
